export default class NavigationItem {
  public readonly link: string;
  public readonly label: string;

  constructor(link: string, label: string) {
    this.link = link;
    this.label = label;
  }
}
